import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionAnswer, TopicAnswers } from '@app/_models';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'conclusion.component.html', selector: 'conclusion' })
export class ConclusionComponent {

    loading = false;
    sectionId: any;
    conclusion: any;
    secondSection: any;
    caseStudySection: any;
    textSection: any;
    answers: any;
    theme: string = 'light';
    resultText: string = '';
    audioconclusion: any;


    constructor(private route: ActivatedRoute, private courseService: CourseService, private shareService: TopicShareService) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');
            this.getSection();
            this.getAssessmentAnswers();
            this.shareService.emitter.emit(true);
        });
    }

    getSection() {
        this.courseService.getSection(this.sectionId).pipe(first()).subscribe(data => {
            this.loading = false;
            this.conclusion = data.section;
            this.secondSection = this.conclusion.contents.find(c => c.discriminator == "AudioContent");
            this.caseStudySection = this.conclusion.contents.find(c => c.discriminator == "CaseStudyContent");
            this.textSection = this.conclusion.contents.find(c => c.discriminator == "HtmlText");
            this.theme = data.theme.toLowerCase();
        });
    }

    getAssessmentAnswers() {
        this.courseService.getAssessmentAnswers().pipe(first()).subscribe(data => {
            this.answers = [];
            data.map(d => {
                let value = 1;
                if (d.answer.answer == "Sprouting") {
                    value = 1.6;
                }
                if (d.answer.answer == "Blooming") {
                    value = 2.3;
                }
                if (d.answer.answer == "Full Bloom") {
                    value = 3;
                }

                let key = d.order;
                let answer = { [key]: value };
                this.answers.push(value);
            })
            
            let answersValues = this.answers;

            let value1 = 1;
            let value16 = 1.6;
            let value23 = 2.3;
            let value3 = 3;

            let value1Count = { length: answersValues.filter((v) => (v === value1)).length, value: 1 };
            let value16Count = { length: answersValues.filter((v) => (v === value16)).length, value: 1.6 };
            let value23Count = { length: answersValues.filter((v) => (v === value23)).length, value: 2.3 };
            let value3Count = { length: answersValues.filter((v) => (v === value3)).length, value: 3 };

            let mostAppearedValue = [value1Count, value16Count, value23Count, value3Count].sort((one, two) => (one.length > two.length ? -1 : 1))[0];

            switch (mostAppearedValue.value) {
                case 1:
                    this.resultText = "<p>It’s an exciting time for you. You are just starting out on your equity journey. </p><p>You will begin to learn more about you, and how equity applies to your life and work.</p>";
                    this.audioconclusion = "https://equityisdynamic-static.s3.amazonaws.com/peb/conclusion/EEx_Section+17a.wav";
                    break;
                case 1.6:
                    this.resultText = "You’re on your way! You have an awareness of what is needed to practice equity, and you’re ready to begin.";
                    this.audioconclusion = "https://equityisdynamic-static.s3.amazonaws.com/peb/conclusion/EEx_Section+17b.wav";
                    break;
                case 2.3:
                    this.resultText = "<p>You’re nearly there! You’ve decided that equity is important and have started to implement equitable practices. </p><p>You may be wondering where to go from here and what other practices you might incorporate.</p>"
                    this.audioconclusion = "https://equityisdynamic-static.s3.amazonaws.com/peb/conclusion/EEx_Section+17c.wav";
                    break;
                case 3:
                    this.resultText = "<p>You’ve really blossomed! Equity is very important to you because it shows in how you run your company and live your life.</p><p>Now, you’re ready to evaluate the effectiveness of your practices and adapt them. You’re also in a position to determine how to best help other companies and entrepreneurs benefit from what you’ve planted.</p>";
                    this.audioconclusion = "https://equityisdynamic-static.s3.amazonaws.com/peb/conclusion/EEx_Section+17d.wav";
                    break;
            }
        });
    }

    save() {
        return this.courseService.addProgress(this.sectionId);
    }
}